import { OnInit, Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
@Component({
  selector: 'formly-field-file',
  template: `
    <div class="d-flex flex-row">
      <div class="flex-initial d-flex justify-end items-start">
        <button
          type="button"
          (click)="fileInput.click()"
          color="accent"
          class="self-center"
          mat-raised-button
        >
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>

      <p class="filename-label flex-1">
        {{ fileName || 'ticket.create.label__select_file' | translate }}
      </p>
      @if (formatError) {
        <p class="mat-error flex-1">
          {{ 'formErrors.file.format' | translate: { accept: to.accept } }}
        </p>
      }
      @if (sizeError) {
        <p class="mat-error flex-1">
          {{ 'formErrors.file.size' | translate: { maxSize: to.maxFileSizeInMB } }}
        </p>
      }
      @if (formControl.errors && formControl.touched) {
        <p class="mat-error flex-1">
          {{ 'formErrors.file.select' | translate }}
        </p>
      }
      @if (fileNameLengthError) {
        <p class="mat-error flex-1">
          {{ 'fileUpload.error.message__filename_length_too_large' | translate }}
        </p>
      }
      @if (fileSizeTooSmallError) {
        <p class="mat-error flex-1">
          {{ 'fileUpload.error.message__file_size_too_small' | translate }}
        </p>
      }

      <input
        #fileInput
        type="file"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [accept]="to.accept"
        hidden
        required
        (change)="onFileSelected($event)"
      />
    </div>
  `,
  styles: [
    `
      :host > div {
        /* MDC: Anhang-Button und Dateiname vertikal mittig */
        align-items: center;
      }

      .filename-label {
        word-break: break-all;
        padding-left: 10px;
        margin: 0;
      }

      button[mat-raised-button] {
        /* MDC: Icon-only-Button kompakt statt 64px-Minimum */
        min-width: 48px;
        padding: 0 12px;
      }

      .error {
        color: red;
      }
    `,
  ],
  standalone: false,
})
export class FormlyFieldFileComponent extends FieldType implements OnInit {
  field: FormlyFieldConfig;

  selectedFile: File;

  fileName: string;

  formatError = false;

  sizeError = false;

  fileNameLengthError = false;

  fileSizeTooSmallError = false;

  ngOnInit() {
    this.formatError = false;
    this.sizeError = false;
    this.fileName = '';
    this.fileNameLengthError = false;
    this.fileSizeTooSmallError = false;
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0] as File;
    this.sizeError = false;
    this.formatError = false;
    this.fileName = '';

    const selectedFileExtensionArray = this.selectedFile.name.split('.');
    const selectedFileExtensionArrayLength = selectedFileExtensionArray.length;
    if (
      this.field.templateOptions?.accept &&
      !this.field.templateOptions?.accept
        ?.toLowerCase()
        .includes(selectedFileExtensionArray[selectedFileExtensionArrayLength - 1].toLowerCase())
    ) {
      this.formatError = true;
      return;
    }
    if (
      this.field.templateOptions?.maxFileSizeInMB &&
      this.selectedFile.size > this.field.templateOptions?.maxFileSizeInMB * 1e6
    ) {
      this.sizeError = true;
      return;
    }
    if (this.selectedFile.name.length > 150) {
      this.fileNameLengthError = true;
      return;
    }

    if (this.selectedFile.size <= 0) {
      this.fileSizeTooSmallError = true;
      return;
    }

    this.fileName = `${this.selectedFile.name} (${(this.selectedFile.size / 1e6).toFixed(2)} MB)`;
    this.formControl.patchValue(this.selectedFile);
  }
}
